module.exports = __webpack_public_path__ + "img/help-24px-blue.c31d2587.svg";